import { ApiSlugs, ListPagination, SmsDto, SmsId } from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../api-caller.service';
import { ApiConnector } from '../../../api-connector.abstract-service';
import { QueryParamsUtils } from '../../../utils/query-params.utils';

export class SmsAdminConnector extends ApiConnector<SmsDto, SmsDto, SmsId> {
  constructor(apiCaller: ApiCaller, apiPrefix: string) {
    super(apiCaller, apiPrefix, ApiSlugs.SMS);
  }

  summerized = () => ({
    list: (pagination?: ListPagination): Observable<SmsDto[]> =>
      this.apiCaller.getRequest<SmsDto[]>(
        this.apiPrefix,
        `${this.slug}/all${QueryParamsUtils.buildFilterParams(pagination)}`,
      ),
    count: (pagination?: ListPagination): Observable<number> =>
      this.apiCaller.getRequest<number>(
        this.apiPrefix,
        `${this.slug}/all/count${QueryParamsUtils.buildFilterParams(pagination, true)}`,
      ),
  });

  resend = (smsId: SmsId): Observable<SmsDto> =>
    this.apiCaller.postRequest<SmsDto>(this.apiPrefix, `${this.slug}/${smsId}/resend`);
}
